import * as uploadTypes from 'types/upload';

export const requestUploadContactFile = (files, change, prevEmails) => ({
    type: uploadTypes.REQUEST_UPLOAD_EMAIL_FILES,
    files,
    change,
    prevEmails
});
